module.exports = __webpack_public_path__ + "static/media/6.2.dfe43a7f.png";